import { Alert, AlertIcon } from '@chakra-ui/react';
import * as React from 'react';

export const PaidSponsorInfo: React.FC = () => {
  return (
    <Alert status="info" colorScheme="gray">
      <AlertIcon />
      These settings give paid tier sponsors ‘read only’ access to this group
    </Alert>
  );
};
